import { axios } from "../config";

export const downloadHolidayList = async (params) => {
  const response = await axios.get("/api/v1/institutions/calendar-exceptions", {
    params,
    responseType: "blob",
  });
  return window.URL.createObjectURL(new Blob([response.data]));
};

export const createHoliday = async (data) => {
  return axios.post("/api/v1/institutions/create-calendar-exception", data);
};

export const editHoliday = async (id, data) => {
  return axios.put(`/api/v1/institutions/calendar-exception/${id}`, data);
};

export const deleteHoliday = async (id) => {
  return axios.delete(`/api/v1/institutions/calendar-exception/${id}`);
};

export const getAttendanceStat = () => {
  return axios.get("api/v1/analytics/teacher-attendance-stats");
};

export const getLeaveOverview = async (params) => {
  return axios.get("/api/v1/analytics/teacher-leave-overview", {
    params,
  });
};

export const leaveAction = (id, status) => {
  return axios.put(
    `/api/v1/analytics/approve-leave/${id}`,
    {},
    {
      params: {
        status: status,
      },
    }
  );
};
